<template>
  <div class="template">
    <div class="search">
      <div>
        <Input
          v-model="search.search_name"
          placeholder="请输入联系人或联系电话"
          style="width: 310px; margin-right: 10px"
          icon="ios-search"
        ></Input>
        <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
      </div>
      <Button type="primary" icon="ios-download" @click="downloadAll">下载所有名单</Button>
    </div>
    <div class="table">
      <Tabs type="card" v-model="search.status" @on-click="searchFn">
        <TabPane name="all" label="全部"></TabPane>
        <TabPane name="0" label="审核中"></TabPane>
        <TabPane name="1" label="审核通过"></TabPane>
        <TabPane name="2" label="审核不通过"></TabPane>
      </Tabs>
    </div>

    <Table border :columns="diyData.columns" :data="apiData.tableList">
      <template slot="footer">
        <Page
          :total="apiData.total"
          show-total
          :page-size="apiData.per_page"
          :current="search.page"
          class-name="footer-page"
          @on-change="pageChange"
        ></Page>
      </template>
    </Table>

    <!-- 更新名单 -->
    <Modal v-model="diyDom.showUpload" title="更新名单" footer-hide>
      <div class="upload-modal">
        <Upload
          :action="uploadUrl"
          :headers="token"
          :on-error="uploadErr"
          :on-success="uploadSuccess"
          name="file"
          :show-upload-list="false"
          ref="upload"
        >
          <Button type="primary" icon="ios-cloud-upload-outline">上传报名名单</Button>
        </Upload>
        <div class="tips">*新名单将覆盖旧名单，请谨慎操作</div>
      </div>
    </Modal>

    <!-- 编辑信息 -->
    <edit-user v-model="diyDom.showEdit" :id="diyData.id" @on-success="editUserSucc"></edit-user>
    <!-- 审核 -->
    <inspectModal v-model="diyDom.showInspect" :id="diyData.id" @on-success="getTableList"></inspectModal>
  </div>
</template>

<script>
  import editUser from './edit-user.vue'
  import inspectModal from './inspect-modal.vue'
  import * as apiCompetition from '@/api/activity/competitions'
  import downloadBlob from '@/utils/downloadBlob'
  export default {
    name: 'signup-list',
    components: {
      editUser,
      inspectModal,
    },
    data() {
      return {
        query: {},
        search: {
          status: 'all',
          search_name: '',
          page: 1,
        },
        diyDom: {
          showUpload: false,
          showEdit: false,
          showInspect: false,
        },
        diyData: {
          id: '',
          columns: [
            {
              title: 'ID',
              render: (h, params) => {
                return h('div', params.index + 1)
              },
            },
            {
              title: '联系人',
              key: 'contact_name',
            },
            {
              title: '联系电话',
              key: 'contact_mobile',
            },
            {
              title: '审核状态',
              key: 'status_lab',
            },
            {
              title: '报名名单',
              render: (h, params) => {
                return h('div', [
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.$store.commit('setSpinShow', true)
                          apiCompetition
                            .apiCompetitionsSignExportSingle(params.row.id,{
                              t:new Date().getTime()
                            })
                            .then(res => {
                              this.downloadFn(res)
                            })
                            .finally(() => this.$store.commit('setSpinShow', false))
                        },
                      },
                    },
                    '下载'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.diyData.id = params.row.id
                          this.diyDom.showUpload = true
                        },
                      },
                    },
                    '更新名单'
                  ),
                ])
              },
            },
            {
              title: '报名时间',
              key: 'created_at',
            },
            {
              title: '更新时间',
              key: 'updated_at',
            },
            {
              title: '操作',
              fixed: 'right',
              render: (h, params) => {
                return h('div', [
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.diyData.id = params.row.id
                          this.diyDom.showEdit = true
                        },
                      },
                    },
                    '编辑'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.diyData.id = params.row.id
                          this.diyDom.showInspect = true
                        },
                      },
                    },
                    '审核'
                  ),
                ])
              },
            },
          ],
        },
        apiData: {
          total: 0,
          per_page: 0,
          tableList: [],
        },
      }
    },
    methods: {
      // 获取表格数据
      getTableList() {
        this.$store.commit('setSpinShow', true)
        apiCompetition
          .apiCompetitionsSignList({ ...this.search, ...this.query })
          .then(res => {
            const { data, meta } = res
            this.apiData.tableList = data
            this.apiData.per_page = meta.pagination.per_page
            this.apiData.total = meta.pagination.total
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      // 分页
      pageChange(e) {
        this.search.page = e
        this.getTableList()
      },
      // 搜索
      searchFn() {
        this.search.page = 1
        this.getTableList()
      },
      // 清空
      clearFn() {
        this.search = {
          search_name: '',
          page: 1,
        }
        this.getTableList()
      },
      // 编辑信息成功
      editUserSucc() {
        this.getTableList()
      },
      // 下载所有
      downloadAll() {
        this.$store.commit('setSpinShow', true)
        apiCompetition
          .apiCompetitionsSignExportAll(this.query.com_id,{
            t:new Date().getTime()
          })
          .then(res => {
            this.downloadFn(res)
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      // 执行下载
      downloadFn(res) {
        downloadBlob(res)
      },
      // 更新名单
      uploadSuccess(e) {
        if (e.code == 0) {
          apiCompetition
            .apiCompetitionsSignUpdate(this.diyData.id, {
              registration_list_url: e.data.path,
            })
            .then(() => {
              this.$Message.success('更新名单成功')
              this.getTableList()
              this.diyDom.showUpload = false
            })
        } else {
          this.$Modal.error({
            title: '提示',
            content: e.message,
          })
        }
      },
      uploadErr() {
        this.$Modal.error({
          title: '提示',
          content: '文件上传失败，请重试',
        })
      },
    },
    computed: {
      uploadUrl() {
        return process.env.VUE_APP_API_URL + `/admin/upload/file`
      },
    },
    mounted() {
      this.query = this.$route.query
      this.getTableList()
    },
  }
</script>

<style scoped lang="less">
  .template {
    .search {
      display: flex;
      justify-content: space-between;
    }
    .table {
      margin-top: 10px;
    }
    .filter {
      margin: 10px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 6px 0 20px 0;
      flex-wrap: wrap;
      border: 1px solid rgba(237, 237, 237, 1);

      .filter-item {
        margin: 14px 0 0 20px;

        .title {
          margin-right: 10px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
          line-height: 17px;
        }
      }
    }
  }
  .upload-modal {
    padding: 40px 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .tips {
      margin-top: 10px;
    }
  }
</style>
